import React from "react";
import ReactDOM from "react-dom";
import funnel from "../../assets/funnel.png";
import { AiOutlineCloseCircle, AiOutlineClose } from "react-icons/ai";
import { GoIssueClosed } from "react-icons/go";
import { BsGraphUpArrow } from "react-icons/bs";
const ScoreModal = ({ open, onClose }) => {
  if (!open) return null;
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-10 overflow-y-auto bg-black bg-opacity-50">
      <div className="flex justify-center">
        <div className="flex flex-col bg-white mt-8 rounded w-96 h-96">
          <div className="flex justify-end text-gray-500 m-3">
            <button className="" onClick={onClose}>
              <AiOutlineClose />
            </button>
          </div>
          <div className="flex items-center justify-center">
            <div>
              <img src={funnel} apt="funnel" className="h-14" />
            </div>
          </div>
          <p className="text-center text-lg font-bold mx-8 mt-2">
            Oops... your <span className="text-red-400">free plan</span> doesn't
            support advanced filters.
          </p>
          <div className="px-4">
            <p className="text-gray-500 text-center text-xs flex-wrap mt-2">
              Join the family of 24,453 premium users that send
              hyper-personalized campaigns with advanced filters.
            </p>
          </div>
          <div className="flex flex-col mt-4 bg-gray-200 h-24">
            <p className="text-xs mt-5 mb-3 text-center">
              FEATURE AVAILABLE IN:
            </p>
            <div className="flex justify-center items-center">
              <div className="flex justify-center items-center mx-2">
                <AiOutlineCloseCircle className="text-red-600 mr-1" /> Free
              </div>
              <p className="text-gray-400">|</p>
              <div className="flex justify-center items-center mx-2">
                <GoIssueClosed className="text-green-700 mr-1" /> Basic
              </div>
              <p className="text-gray-400">|</p>
              <div className="flex justify-center items-center mx-2">
                <GoIssueClosed className="text-green-700 mr-1" /> Pro
              </div>
              <p className="text-gray-400">|</p>
              <div className="flex justify-center items-center mx-2">
                <GoIssueClosed className="text-green-700 mr-1" /> Org
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center h-[4rem]">
            <button className="bg-blue-700 text-white text-sm h-[32px] rounded w-1/3">
              View Pricing Plans{" "}
            </button>
          </div>
          <div className="flex justify-center mb-4">
            <BsGraphUpArrow className="text-gray-500 text-sm mr-2"/>
            <p className="text-xs text-center">
              ~20% better results for premium users.
            </p>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("score-modal")
  );
};

export default ScoreModal;
